export default "__VITE_ASSET__BNinsMJU__"